import React from 'react';
import { SxProps } from '@mui/material';
import {
    ColumnDatatable,
    FiltersDatatableList,
    PreFilterDatatableList,
    RowSelectionActionList,
    StoreDatatable,
} from '@europrocurement/flexy-datatable';
import { DataSource } from '@europrocurement/l2d-redux-utils';
import { CollectionOpenSearch, useFormaliteService, useSociete } from '@europrocurement/l2d-domain';

export type OrderTableProps = {
    datasource: DataSource<CollectionOpenSearch>;
    columns: ColumnDatatable<CollectionOpenSearch>[];
    preFilters?: PreFilterDatatableList;
    filters: FiltersDatatableList;
    rowActions?: RowSelectionActionList;
    onRowClick: (item: CollectionOpenSearch) => void;
    onWheelClick: (item: CollectionOpenSearch) => void;
};

const OrderTable: React.FunctionComponent<OrderTableProps> = function ({
    datasource,
    columns,
    preFilters,
    filters,
    rowActions,
    onRowClick: handleRowClick,
    onWheelClick: handleRowWheelClick,
}) {
    const xIdSociete = useSociete();
    const { getOpenSearchCollections } = useFormaliteService();

    return (
        <StoreDatatable
            dataSource={datasource}
            columns={columns}
            computeSxRow={(item: CollectionOpenSearch) =>
                item.critical
                    ? ({
                          '&>td:first-of-type': {
                              borderLeft: '4px solid',
                              borderLeftColor: 'error.main',
                          },
                      } as SxProps)
                    : {}
            }
            computeSxRowHover={() => ({
                '.company-name': {
                    transition: 'color 0.25s ease',
                    color: 'primary.main',
                },
            })}
            fetchData={getOpenSearchCollections}
            localStorageKey="FlexyStoreDatatable"
            observers={[xIdSociete]}
            sx={{ marginBottom: '2.25em' }}
            preFilters={preFilters}
            filters={filters}
            onClickRow={(_: React.MouseEvent<HTMLElement>, item: CollectionOpenSearch) => {
                handleRowClick(item);
            }}
            onWheelClickRow={(_: React.MouseEvent<HTMLElement>, item: CollectionOpenSearch) => {
                handleRowWheelClick(item);
            }}
            rowsActions={rowActions}
        />
    );
};

export default OrderTable;
